import type {
  User,
  UserCallCenterAgentSkillRequest,
  UserSearchParams,
  Worker,
} from '@/domain/user';
import { api } from '@/utils/configuration';
import { crudService } from '@/utils/request';
import type { GenericAbortSignal } from 'axios';
import type { Operation } from 'fast-json-patch';

export const UserService = {
  search: (params: UserSearchParams, signal?: GenericAbortSignal) =>
    crudService.get<User[]>(api.USER, { params, signal }),

  findById: (id: number, signal?: GenericAbortSignal) =>
    crudService.get<User>(`${api.USER}/${id}`, { signal }),

  me: (signal?: GenericAbortSignal) => crudService.get<User>(`${api.USER}/me`, { signal }),

  patch: (id: number, operations: Operation[], version: number) =>
    crudService.patch<User>(operations, `${api.USER}/${id}?version=${version}`),

  updateWorkerActivity: (userId: number, activitySid: string): Promise<void> =>
    crudService.put<void>({}, `${api.USER}/${userId}/call-center-agent/activity`, {
      params: { activitySid },
    }),

  createContactCenterAgent: (userId: number): Promise<User> =>
    crudService.post<User>({}, `${api.USER}/${userId}/call-center-agent`),

  findCallCenterAgent: (id: number, signal?: GenericAbortSignal) =>
    crudService.get<Worker>(`${api.USER}/${id}/call-center-agent`, { signal }),

  addSkill: (userId: number, request: UserCallCenterAgentSkillRequest): Promise<void> =>
    crudService.post<void>(request, `${api.USER}/${userId}/call-center-agent/skills`),

  updateSkill: (userId: number, request: UserCallCenterAgentSkillRequest): Promise<void> =>
    crudService.put<void>(request, `${api.USER}/${userId}/call-center-agent/skills`),

  deleteSkill: (userId: number, skillName: string): Promise<void> =>
    crudService.delete<void>(`${api.USER}/${userId}/call-center-agent/skills/${skillName}`),
};
